// RITA-1523 (Nutzungserfassung, Versionsvergleich) — Eimer-Leitern der Richtungslogik.
//
// Die Mediane der Auswertung sind NÄHERUNGEN aus den Tages-Histogrammen: der Server interpoliert
// innerhalb eines Eimers (percentiles.ts CONTRACT 4). Zwischen 10 s und 30 s hat die
// Verweildauer-Leiter einen einzigen Eimer, LCP läuft in 500-ms-Stufen — ein ausgewiesenes
// „+4,2 s" kann allein ein Eimerwechsel bei unveränderter Wirklichkeit sein. Die Änderungsspalte
// des Vergleichs gibt deshalb keine Differenz aus, sondern eine Richtung mit Schwelle:
// „unverändert", solange beide Werte im SELBEN Eimer liegen (CONTRACT 3b V6).
//
// Dafür braucht das Frontend die Kanten. Das ist eine ZWEITE Quelle neben
// apps/backend/src/services/usage/percentiles.ts und bewusst so: die Schwelle ist eine Aussage der
// Oberfläche über die Genauigkeit der Zahl, keine Rechnung des Servers. Gebunden ist sie durch
// eimerLeitern.test.ts — der Test LIEST die Backend-Datei und vergleicht die Kanten. Wer dort eine
// Kante verschiebt, macht ihn rot; ohne ihn würde aus „unverändert" still ein „länger", und die
// Zahl daneben bliebe dieselbe.
//
// Eimer sind OBEN GESCHLOSSEN (percentiles.ts CONTRACT 2): ein Wert fällt in den ersten Eimer,
// dessen Obergrenze er nicht überschreitet; alles über der letzten Kante liegt im Überlauf.

/** Obergrenzen der Verweildauer in ms — Spiegel von VISIBLE_HIST_EDGES. */
export const VISIBLE_HIST_EDGES: readonly number[] = [2000, 5000, 10000, 30000, 60000, 120000, 300000, 600000, 1800000];

/** Obergrenzen des LCP in ms — Spiegel von VITAL_HIST_EDGES.LCP. */
export const LCP_HIST_EDGES: readonly number[] = [500, 1000, 1500, 2000, 2500, 3000, 4000, 6000, 8000, 12000];

/**
 * Stelle des Eimers, in den ein Wert fällt (0 = unterster). Werte über der letzten Kante liegen
 * alle im Überlauf-Eimer und gelten damit als derselbe Eimer — genau das ist die Aussage der
 * Textmarke '> letzte Kante' im Bestand: oberhalb der Leiter gibt es keine Genauigkeit mehr.
 */
export const eimerStelle = (wert: number, leiter: readonly number[]): number => {
  const stelle = leiter.findIndex((kante) => wert <= kante);
  return stelle === -1 ? leiter.length : stelle;
};
